import { render } from "./GenerateDocument.vue?vue&type=template&id=bb4ca4fc&scoped=true"
import script from "./GenerateDocument.vue?vue&type=script&lang=js"
export * from "./GenerateDocument.vue?vue&type=script&lang=js"

import "./GenerateDocument.vue?vue&type=style&index=0&id=bb4ca4fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb4ca4fc"]])

export default __exports__